import classNames from 'classnames'
import css from './author_profile.scss'

const Education = ({ author }) => {
  if (author.educationalBackground && author.educationalBackground.length > 0) {
    return (
      <div id="education" className={classNames(css.authorProfileSection)}>
        <h2>Education</h2>
        <ul>
          {author.educationalBackground.map((education, i) => (
            <li key={i}>
              <strong>{education.institutionName}</strong>, {education.degree}{' '}
              in {education.fieldOfStudy}
            </li>
          ))}
        </ul>
      </div>
    )
  } else {
    return null
  }
}

export default Education
